// extracted by mini-css-extract-plugin
module.exports = {"bgQuoteFamily":"quote_bgQuoteFamily__Z22_T","bgQuote":"quote_bgQuote__Q9Wy7","center":"quote_center__jexqX"};